import { Link } from 'react-router';
import { Button } from './ui/button';
import { CheckCircleIcon } from 'lucide-react';

const CtfAchievements = [
  {
    title: 'Comprehensive Analytics',
  },
  {
    title: 'Collaboration & Engagement',
  },
  {
    title: 'Flexible CTF Modes',
  },
  {
    title: 'Extensive Challenge Library',
  },
];
export default function CTFCompetition() {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-4 text-center">
        <span className="text-lightBlue text-[15px] font-bold uppercase">Our Products</span>
        <h1 className="text-[50px] font-medium">An all-in-one LMS to upskill your security team</h1>
        <p className="text-lighterBlack pt-5 pb-10 text-[20px] font-light">
          We offer you with a comprehensive range of tools to host real-world CTF competitions.
        </p>
      </div>
      <div className="items-center justify-between gap-10 md:flex">
        <div className="flex flex-col gap-4">
          <img src="/images/ctf.png" alt="CTF Competition" className="md:w-[560px]" />
        </div>
        <div className="flex flex-col gap-4 md:w-1/2">
          <span className="text-lightBlue text-[15px] font-bold uppercase">Challenge</span>
          <h1 className="text-[42px] font-medium">Capture The Flag Competitions</h1>
          <p className="text-lighterBlack mb-5 text-[20px] leading-10 font-light">
            With our platform, you can enhance your employees' or students' skills by creating
            custom CTF competitions, tailored to your specific needs. Craft unique challenges and
            scenarios that simulate real-world situations, allowing you to evaluate their expertise
            effectively.
          </p>
          <div className="grid grid-cols-2 gap-4">
            {CtfAchievements.map((achievement) => (
              <div className="flex items-center gap-2">
                <CheckCircleIcon className="text-lightBlue" />
                <span className="text-[15px] font-light">{achievement.title}</span>
              </div>
            ))}
          </div>
          <Button variant="default" className="mt-5 w-fit" asChild>
            <Link to="/host-ctf"> Explore Features</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
